<template>
  <ButtonSnsSmall class="btn-sns--others" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-others-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--others {
  @include bg-settings(
    '../../../../../../images/buttons/others-with-background.svg',
    $gray-2,
    100%,
    100%
  );
}
</style>
